import image1 from "../assets/images/resource/featured-image-1.jpg";
import image3 from "../assets/images/resource/featured-image-15.jpg";
import image2 from "../assets/images/resource/featured-image-2.jpg";
import image12 from "../assets/images/update-01-10-2021/resources/about-10-1-1.jpg";
import image11 from "../assets/images/update-01-10-2021/resources/about-11-1-3.jpg";
import image10 from "../assets/images/update-01-10-2021/resources/about-eight-1-1.png";
import image9 from "../assets/images/update-01-10-2021/resources/about-nine-1-1.png";
import image6 from "../assets/images/update-01-10-2021/resources/about-seven-1-1.jpg";
import image7 from "../assets/images/update-01-10-2021/resources/about-seven-1-2.jpg";
import image8 from "../assets/images/update-01-10-2021/resources/about-six-1-1.jpg";
import image4 from "../assets/images/update-1-12-2020/resources/about-1-1.jpg";
import image5 from "../assets/images/update-1-12-2020/resources/signture-1-1.png";
import image13 from "../assets/images/update-26-02-2021/resources/about-me-1.png";

export const aboutSectionOne = {
  image1,
  image2,
  title: "EXCELLENCE IS OUR STANDARD,\nNOT JUST A GOAL",
  text1:
    "This ethos drives us to provide our clients with bespoke solutions that transcend their expectations.",
  text2:
    "Lorem Ipsum is simply dummy text of free available in market the printing and typesetting industry has been the industry's standard dummy text ever.",
  textList: [
    "Tailored Branding Solutions.",
    "Custom Web Solutions.",
    "Targeted Marketing Strategies.",
  ],
  since: "2019",
};

export const aboutSectionTwo = {
  image: image3,
  title: "We are standout\nexperts in business",
  text: "We believe that success is achieved through a highly collaborative interaction, so that we can work together to identify and evaluate opportunities beyond your current operations.",
  counters: [
    { id: 1, percent: 90, title: "Quality\nServices" },
    { id: 2, percent: 50, title: " Skilled\nEmployee" },
  ],
  since: "2008",
};

export const aboutSectionThree = {
  image: image4,
  title: "The Right People for your Business",
  subtitle: "welcome to business agency",
  text: "There are many variations of passages of available but the majority have suffered alteration in some form, by injected humou or randomised words which don look even slightly believable.",
  lists: [
    "If you are going to use a passage",
    "Lorem Ipsum is not simply random text",
    "Making this the first true generator on the Internet",
  ],
  barTitle: "Bussiness Success",
  barPercent: 70,
  aboutPerson: { name: "William Smith", tagline: "Co Founder", image: image5 },
};

export const aboutSeven = {
  images: [image6, image7],
  tagline: "About Company",
  title: "We provide the best business services",
  text: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, simply free text by injected humour, or randomised.",
  title2: "azk-khan is the largest digital marketing agency.",
  lists: [
    "We’re professional and certified designers",
    "We use quality material to make your walls awesome",
    "We care about our customers satisfaction",
  ],
};

export const aboutSix = {
  tagline: "Our Company Benefits",
  title: "Mission is to protect your business",
  text: "There are many variations of passages of available but the majority have suffered alteration in some form, injected humou or randomised words slightly believable.",
  image: image8,
  items: [
    {
      id: 1,
      title: "We combine tech with business",
      icon: "flaticon-idea",
    },
    {
      id: 2,
      title: "The right people for your businesses",
      icon: "flaticon-mouse",
    },
    {
      id: 3,
      title: "Best way of running a business",
      icon: "flaticon-briefcase",
    },
  ],
};

export const aboutNine = {
  image: image9,
  icon: "flaticon-data",
  title: "Powerful Tools for Your Customers",
  titleHighlight: "Tools",
  text: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
  lists: [
    "Refresing to get such a personal touch.",
    "Duis aute irure dolor in reprehenderit in voluptate.",
    "Velit esse cillum dolore eu fugiat nulla pariatur.",
  ],
};

export const aboutEight = {
  image: image10,
  icon: "flaticon-data",
  title: "Control Everything from One Solution",
  titleHighlight: "Everything",
  text: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. fur hat and fur boa who sat upright, raising a heavy fur muff that covered.",
  progresses: [
    {
      id: 1,
      text: "Marketing",
      count: 77,
    },
    {
      id: 2,
      text: "SEO Optimization",
      count: 89,
    },
  ],
};

export const aboutEleven = {
  images: ["about-11-1-1.jpg", "about-11-1-2.jpg"],
  tagline: "Our Company Introduction",
  title: "We Ensure Only Quality Consulting Services for our Clients",
  text: "Quis aliqua sunt nisi consectetur anim ullamco ea deserunt non voluptate nisi sit elit exercitation eu Lorem. Mollit occaecat nisi occaecat fugiat ullamco.",
  boxes: [
    {
      id: 1,
      icon: "flaticon-headhunting",
      title: "Qualified Consultants",
    },
    {
      id: 2,
      icon: "flaticon-background-check",
      title: "Trusted Since 1987",
    },
  ],
  progressTitle: "Finance & Consulting",
  percent: 77,
  image: image11,
  name: "Christine Eve",
  infoText: "Co Founder & Consultant",
};

export const aboutTen = {
  image: image12,
  tagline: "Why Choose Us",
  title: "The Largest Business Experts",
  text: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
  boxes: [
    {
      id: 1,
      title: "Customer Experience",
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Dolor sit amet, adipsicing elit.",
    },
    {
      id: 2,
      title: "Customer Experience",
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Dolor sit amet, adipsicing elit.",
    },
  ],
};

export const contactInfo = [
  {
    id: 1,
    image: "https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png",
    label: "Email",
    value: "Email Address",
    link: "mailto:ashhad.k2@gmail.com",
  },
  {
    id: 2,
    image: "https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png",
    label: "LinkedIn",
    value: "LinkedIn Profile",
    link: "https://linkedin.com/in/ashhad_zak",
  },
  {
    id: 3,
    image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    label: "GitHub",
    value: "GitHub Profile",
    link: "https://github.com/AshhadK",
  },
];


export const aboutMeOne = {
  image: image13,
  name: 'Ashhad Zafar Khan',
  title: 'Software Engineer | NED University of Engineering and Technology',
  text: "I started my academic journey at Habib Public School, where I studied till 5th grade. Following that, I made a transition to Iqra for my religious studies, dedicating three years to memorizing the Holy Quran with distinction in Wifaqul Madarais.",
  text2: "Later, I joined Happy Palace Grammar School in the 9th grade and secured an impressive A-1 Grade with a percentage of 86.8% in the SSC Examinations, earning the third rank in my school. This achievement paved the way for my admission to Govt. Dehli College, where I maintained my academic excellence, securing 84% - A1 grade. Driven by a passion for engineering, I set my sights on NED University. After rigorous preparation and successful performance on the admission test, I proudly gained admission into the top merit field at NED UET – Software Engineering. This journey reflects my commitment to both religious and academic pursuits.",
  text3: "Afterward, I got admitted to my dream University where I studied Software Engineering and learned to create all sorts of exciting digital things. I’ve begun my career by making games! I made a car racing game, an exciting space shooting game, and one of the classics Pacman using Python. Using C# I’ve also made another classic which is Flappy Bird. The assets used in all these games had been entirely designed by myself. When I'm not busy coding, I'm letting my creative side loose as a UI/UX designer. That means I create awesome pictures, brochures, posters, cards, and presentations. This creative skill helps me make websites and app designs that are not only easy to use but also look fantastic. My collection of work includes an Airline reservation system, which is basically a PHP website through which you can book flights. The system supports flexible booking options, enabling users to reserve multiple tickets and choose their preferred class (Business or Economy) for each passenger. Seamless online payment processing with credit cards ensures a secure and swift transaction experience. Once payment is confirmed, electronic tickets are generated and accessible on the website, with copies sent to users via email for reference.",

  socials: [
    {
      id: 1,
      icon: "fab fa-twitter",
      href: "#",
    },
    {
      id: 2,
      icon: "fab fa-facebook-f",
      href: "#",
    },
    {
      id: 3,
      icon: "fab fa-linkedin-in",
      href: "#",
    },
    {
      id: 4,
      icon: "fab fa-pinterest-p",
      href: "#",
    },
  ],
};

export const aboutMeCounter = {
  title: "Our Expertise",
  counters: [
    {
      id: 1,
      title: "Branding",
      percent: 80,
    },
    {
      id: 2,
      title: "Marketing",
      percent: 70,
    },
    {
      id: 3,
      title: "Design & Development",
      percent: 90,
    },
  ],
};
